import { Flex, Typography } from "antd"

export const GeneratingReportsStepUi = () => {
  return (
    <Flex vertical>
      <Typography.Text>
        In the Reports section, you can request a report for a selected time
        period and have it sent to your email.
      </Typography.Text>

      <ul>
        <li>The report uses UTC time.</li>
        <li>It is delivered in CSV format.</li>
      </ul>
    </Flex>
  )
}
